import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ customer: null, loading: true, refresh: () => {}, logout: () => {}, setCustomer: () => {} });

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/account/me"); setCustomer(data); return data; }
    catch { setCustomer(null); return null; }
    finally { setLoading(false); }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const logout = async () => { await api.post("/account/logout").catch(() => {}); setCustomer(null); };
  return <Ctx.Provider value={{ customer, loading, refresh, logout, setCustomer }}>{children}</Ctx.Provider>;
}

export const useCustomer = () => useContext(Ctx);
